import { BUTTON_TYPES, BUTTON_COLORS, Button } from 'components/Button/Button';
import type { ZipCodeSearchbarProps } from './zip-code-search.types';

function ZipCodeSearchbar({
  handleSubmit,
  inputRef,
  searchPlaceholder = '',
  className = null,
  focusOnRender = null,
}: Readonly<ZipCodeSearchbarProps>) {
  return (
    <div className={`c-search-bar ${className}`}>
      <div className="grid-container grid-x c-search-bar__line">
        <input
          className="c-search-bar__input small-11 medium-11 large-11"
          name="q"
          ref={inputRef}
          type="text"
          placeholder={searchPlaceholder ?? ''}
          autoComplete="off"
          onKeyPress={(event) => {
            if (event.key === 'Enter') handleSubmit(event);
          }}
          {...(focusOnRender ? { autoFocus: true } : {})}
        />
        <div className="small-1 medium-1 large-1 c-search-bar__btn-container">
          <Button
            symbol="search"
            className="c-search-bar__btn"
            onClick={handleSubmit}
            type={BUTTON_TYPES.PLAIN}
            color={BUTTON_COLORS.PRIMARY}
          />
        </div>
      </div>
    </div>
  );
}

export default ZipCodeSearchbar;
